import {SortOrder} from '../sort-order';
import {AlarmType} from "../alarm-type";

export class AlarmFilters {
  alarmDefinitionName: string;
  machineSerialNumber: string;
  activationDate: number;
  deactivationDate: number;
  resetUsername: string;
  machineGroupsUuids: string[];
  organizationUuids: string[];
  alarmType: AlarmType;
  active?: boolean;
  sortField: string;
  sortOrder: SortOrder;
}
